import * as React from "react";
import {
  Image,
  StyleSheet,
  TouchableOpacity,
  View,
  Dimensions,
  SafeAreaView,
  ScrollView,
  StatusBar,
} from "react-native";

import PropTypes from "prop-types";
import { MonoText } from "../components/StyledText";
import { AppDataContext } from "../context/AppDataProvider.js";
import { Ionicons } from "@expo/vector-icons";
import { backendUrl } from "../constants/Environment.js";
import { GlobalSettingsContext } from "../context/GlobalSettingsProvider.js";
import RenderHtml from "react-native-render-html";
import { useWindowDimensions } from "react-native";
import ArticleAd from "./MiscImpl/ArticleAd.js";
import { stateFromHTML } from "draft-js-import-html";
import { EditorState, convertToRaw } from "draft-js";
import NavbarDesktop from "../components/NavbarDesktop";

import CommentBox from "../components/comments/CommentBox";

export default function ArticleScreen({
  navigation,
  route,
  username,
  articleId,
  authToken,
  userId,
  userDetails,
}) {
  const [isLoadingComplete, setLoadingComplete] = React.useState(false);

  const [articles, setArticles] = React.useState([]);

  const [comments, setComments] = React.useState([]);
  const [allowComments, setAllowComments] = React.useState(true);

  const [slideshowEntries, setSlideshowEntries] = React.useState([]);
  const [isSlideshow, setIsSlideshow] = React.useState(false);
  const [slideshowEntryIndex, setSlideshowEntryIndex] = React.useState(0);

  /**
   * Mid-article advert
   */
  const [isShowAd, setShowAd] = React.useState(false);
  const [advertId, setAdvertId] = React.useState("");

  /**
   * To find out the user's reading time for the current article.
   */
  const [currentDate, setCurrentDate] = React.useState(Date.now());

  const { colors } = React.useContext(AppDataContext);

  var height = Dimensions.get("window").height;

  const [allowShowInterstitialAdvert, setAllowShowInterstitialAdvert] =
    React.useState(false);

  const { globalSettings, isLoggedIn } = React.useContext(
    GlobalSettingsContext
  );

  React.useEffect(() => {
    if (articles && articles.length > 0 && articles[0]) {
      if (
        articles[0].category &&
        articles[0].category.category_name &&
        articles[0].category.category_name.toLowerCase() === "slideshow"
      ) {
        setIsSlideshow(true);
      }
      if (
        articles[0].allow_comments === null ||
        articles[0].allow_comments === true
      ) {
        setAllowComments(true);
      } else {
        setAllowComments(false);
      }
    } else {
      setAllowComments(true);
    }
    setSlideshowEntryIndex(0);
  }, [articleId]);

  React.useEffect(() => {
    async function loadGlobalSettings() {
      var settingShowInterstitialAds = globalSettings.find(
        (a) =>
          a.description && a.description.toLowerCase().includes("show end ads")
      );
      if (settingShowInterstitialAds) {
        if (settingShowInterstitialAds.value.toLowerCase() === "true") {
          setAllowShowInterstitialAdvert(true);
        } else {
          setAllowShowInterstitialAdvert(false);
        }
      }
    }

    async function handleAd() {
      var settingDescription = "Show Article Ads";
      var settingsShowBannerAds = globalSettings.find(
        (a) => a.description && a.description.includes(settingDescription)
      );
      if (
        settingsShowBannerAds &&
        settingsShowBannerAds.value &&
        settingsShowBannerAds.value.toLowerCase() === "true"
      ) {
        setShowAd(true);

        /**
         * Get the banner ID
         */
        var bannerAdIdSettingDescription = "Article Ad ID";
        var bannerAdIdSettingResult = globalSettings.find(
          (a) =>
            a.description &&
            a.description.includes(bannerAdIdSettingDescription)
        );
        if (bannerAdIdSettingResult && bannerAdIdSettingResult.value) {
          setAdvertId(bannerAdIdSettingResult.value);
        }
      }
    }

    loadGlobalSettings();
    handleAd();
  }, [globalSettings]);

  /**
   * Checks if the article has an ad in a specific paragraph instead of at the top.
   */
  function hasAd(html) {
    if (!html || html.length < 1) {
      return false;
    }
    return (
      html.includes("[Ad]") || html.includes("[ad]") || html.includes("[AD]")
    );
  }

  function replaceHtml(html) {
    html = html.trim();
    let result = html;
    const contentState = stateFromHTML(result.replace(/\\n/g, " "));
    const editorValue = EditorState.createWithContent(contentState);
    const blocks = convertToRaw(editorValue.getCurrentContent()).blocks;
    const mappedBlocks = blocks.map((block) => block.text.replace(/\\n/g, " "));
    let newText = "";
    for (let i = 0; i < mappedBlocks.length; i++) {
      const block = mappedBlocks[i];
      // handle last block
      if (i === mappedBlocks.length - 1) {
        newText += block;
      } else {
        // otherwise we join with \n, except if the block is already a \n
        if (block === "\n") {
          newText += block;
        } else {
          newText += block + "";
        }
      }
    }
    // result = newText.trim();
    return `${result.replace("[Ad]", "")}`;
  }

  React.useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        /*
         * Load the category's list of articles
         */
        await fetch(backendUrl + "/articles/", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + authToken,
          },
        }).then(function (response) {
          if (response.status !== 200) {
            console.log("Problem in fetching articles");
            return;
          }
          response.json().then(function (data) {
            setArticles(data);
            let filter = data.filter((a) => a.id === articleId);
            if (filter) {
              if (
                filter[0].category &&
                filter[0].category.category_name &&
                filter[0].category.category_name.toLowerCase() === "slideshow"
              ) {
                setIsSlideshow(true);
              }
              if (
                filter[0].allow_comments === null ||
                filter[0].allow_comments === true
              ) {
                setAllowComments(true);
              } else {
                setAllowComments(false);
              }
            } else {
              setAllowComments(true);
            }
          });
        });

        await fetch(backendUrl + "/slideshows/", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + authToken,
          },
        }).then(function (response) {
          if (response.status !== 200) {
            console.log("Problem in fetching slideshows");
            return;
          }
          response.json().then(function (data) {
            let entries = data.filter((a) => a.article_id === articleId)[0];
            if (entries && entries.slots) {
              setSlideshowEntries(entries.slots);
            }
          });
        });
        await fetch(`${backendUrl}/comments/${articleId}`, {
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Accept: "application/json",
            Authorization: "Bearer " + authToken,
          },
        }).then(function (response) {
          if (response.status !== 200) {
            console.log("Error fetching comments for article id " + articleId);
            return;
          }
          response.json().then((data) => {
            setComments(data);
          });
        });
        /**
         * Increment the article's views.
         */
        await fetch(`${backendUrl}/article/visit/${articleId}`, {
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Accept: "application/json",
            Authorization: "Bearer " + authToken,
          },
        }).then(function (response) {
          if (response.status !== 200) {
            console.log("Error appending visits for article id " + articleId);
            return;
          }
          response.json().then((data) => {
            setComments(data);
            console.log(data);
          });
        });
      } catch (e) {
        console.warn(e);
      } finally {
        setLoadingComplete(true);
      }
    }
    loadResourcesAndDataAsync();
  }, [isLoadingComplete]);

  const appendComment = (comment) => {
    var newArray = [...comments];
    newArray.push(comment);
    setComments(newArray);
  };

  const goBackToArticleListScreen = () => {
    /**
     * Submit seconds spent on the current article
     */
    var postDate = new Date();
    var timeDiff = postDate - currentDate;
    timeDiff /= 1000;
    var secondsPassed = Math.round(timeDiff);

    if (isLoggedIn && userId > -1) {
      fetch(`${backendUrl}/article/session/${articleId}/${userId}`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Accept: "application/json",
          Authorization: "Bearer " + authToken,
        },
        body: JSON.stringify({
          seconds: secondsPassed,
        }),
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(
            "Error fetching article session for user id " +
            userId +
            " and article id " +
            articleId
          );
          return;
        }
        response.json().then((data) => {
          setComments(data);
          console.log(data);
        });
      });
    }

    navigation.navigate("ArticleList");
  };

  function getArticleImage() {
    if (isSlideshow) {
      if (!slideshowEntries || slideshowEntries.length < 1) {
        return <></>;
      }
      if (
        slideshowEntryIndex >= slideshowEntries.length ||
        !slideshowEntries[slideshowEntryIndex]
      ) {
        return <></>;
      }
      let slideshowUrlForIndex = `${backendUrl}/slideshow/entry/view-image/${slideshowEntries[slideshowEntryIndex].id}`;
      return (
        <View>
          <MonoText
            style={{
              marginTop: 18,
              color: colors.text,
              fontWeight: "bold",
              fontSize: 18,
            }}
          >
            {articles.length > 0 &&
              articles.find((a) => a && a.id > 0 && a.id === articleId)
                .headline}
          </MonoText>
          <MonoText
            style={{
              marginTop: 18,
              color: colors.text,
              fontSize: 18,
            }}
          >
            {articles.find((a) => a && a.id > 0 && a.id === articleId).summary
              ? articles.find((a) => a && a.id > 0 && a.id === articleId)
                .summary
              : "No article summary found."}
          </MonoText>
          <View
            style={{
              backgroundColor: colors.background,
              height: 256,
              minWidth: 156,
              shadowColor: "#000",
              shadowOffset: {
                width: 0,
                height: 3,
              },
              justifyContent: "center",
              shadowOpacity: 0.27,
              shadowRadius: 4.65,
              elevation: 6,
              marginBottom: 16,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              position: "relative",
              marginTop: 12,
            }}
          >
            <Image
              style={{ height: "100%", width: "100%" }}
              source={{
                uri: slideshowUrlForIndex,
              }}
            ></Image>
          </View>
          <View
            style={{
              flexDirection: "row",
              flexWrap: 1,
              alignContent: "space-between",
              justifyContent: "space-between",
              justifySelf: "flex-start",
            }}
          >
            <TouchableOpacity
              onPress={(a) => {
                setSlideshowEntryIndex((b) => b - 1);
              }}
            >
              <Ionicons
                name={slideshowEntryIndex > 0 ? "md-arrow-back" : ""}
                size={32}
                color={colors.vectorColor}
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={(a) => {
                setSlideshowEntryIndex((b) => b + 1);
              }}
            >
              <Ionicons
                name="md-arrow-forward"
                size={32}
                color={colors.vectorColor}
              />
            </TouchableOpacity>
          </View>
          <View>
            <MonoText
              style={{
                marginTop: 18,
                color: colors.text,
                fontWeight: "bold",
                fontSize: 24,
              }}
            >
              {slideshowEntries[slideshowEntryIndex].title}
            </MonoText>
            <RenderHtml
              tagsStyles={tagsStyles}
              contentWidth={width}
              source={{
                html: `${replaceHtml(
                  slideshowEntries[slideshowEntryIndex].text
                )}`,
              }}
            />
          </View>
        </View>
      );
    }
    return (
      <View>
        <View
          style={{
            backgroundColor: colors,
            height: 256,
            minWidth: 156,
            shadowColor: "#000",
            shadowOffset: {
              width: 0,
              height: 3,
            },
            justifyContent: "center",
            shadowOpacity: 0.27,
            shadowRadius: 4.65,
            elevation: 6,
            marginBottom: 16,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            position: "relative",
            marginTop: 48,
          }}
        >
          <Image
            style={{ height: "100%", width: "100%" }}
            source={{
              uri: backendUrl + "/article/view-image/" + articleId.toString(),
            }}
          ></Image>
        </View>
      </View>
    );
  }

  const tagsStyles = {
    body: {
      whiteSpace: "normal",
      color: colors.text,
    },
    a: {
      color: colors.text,
    },
    p: {
      color: colors.text,
    },
  };

  function getArticleContents() {
    if (isSlideshow) {
      return (
        <View style={{}}>
          {articles.length > 0 && (
            <>
              <RenderHtml
                tagsStyles={tagsStyles}
                contentWidth={width}
                source={{
                  html: `${replaceHtml(
                    articles.find((a) => a && a.id > 0 && a.id === articleId)
                      .text
                  )}`,
                }}
              />
            </>
          )}
        </View>
      );
    }
    let articleContents = articles?.find(
      (a) => a && a.id > 0 && a.id === articleId
    )?.text;
    if (!articleContents) {
      return <></>;
    }
    return (
      <View>
        {articles.length > 0 && (
          <>
            <MonoText
              style={{
                marginTop: 18,
                color: colors.text,
                fontWeight: "bold",
                fontSize: 18,
              }}
            >
              {articles.length > 0 &&
                articles.find((a) => a && a.id > 0 && a.id === articleId)
                  .headline}
            </MonoText>
            <MonoText
              style={{
                marginTop: 18,
                color: colors.text,
                fontSize: 18,
              }}
            >
              {articles.find((a) => a && a.id > 0 && a.id === articleId).summary
                ? articles.find((a) => a && a.id > 0 && a.id === articleId)
                  .summary
                : "No article summary found."}
            </MonoText>
            {hasAd(articleContents) ? (
              <React.Fragment>
                <RenderHtml
                  tagsStyles={tagsStyles}
                  contentWidth={width}
                  source={{
                    html: `${replaceHtml(articleContents.split("[Ad]")[0])}`,
                  }}
                />
                <MonoText>Advert below</MonoText>
                {isShowAd && advertId && (
                  <View
                    style={{
                      backgroundColor: colors.background,
                      borderWidth: 1,
                      borderColor: "gray",
                    }}
                  >
                    <ArticleAd advertId={advertId}></ArticleAd>
                  </View>
                )}
                <RenderHtml
                  tagsStyles={tagsStyles}
                  contentWidth={width}
                  source={{
                    html: `${replaceHtml(articleContents.split("[Ad]")[1])}`,
                  }}
                />
              </React.Fragment>
            ) : (
              <RenderHtml
                tagsStyles={tagsStyles}
                contentWidth={width}
                source={{
                  html: `${replaceHtml(articleContents)}`,
                }}
              />
            )}
          </>
        )}
      </View>
    );
  }

  if (!articles) {
    return null;
  }
  if (!comments) {
    return null;
  }

  var styleDynamic = StyleSheet.create({
    container: {
      backgroundColor: colors.background,
      flex: 1,
      paddingTop: StatusBar.currentHeight,
    },
    textStyle: {
      fontSize: 18,
      paddingLeft: 6,
      fontWeight: "bold",
      color: colors.text,
    },
    scrollView: {
      marginHorizontal: 20,
    },
    vectorStyle: {
      color: colors.vectorColor,
    },
  });
  const { width } = useWindowDimensions();

  return (
    <React.Fragment>
      <View pointerEvents="box-none" style={{ elevation: 2, zIndex: 2, }}>
        <NavbarDesktop
          navigate={navigation.navigate}
          setParams={navigation.setParams}
        />
      </View>
      <SafeAreaView style={styleDynamic.container}>
        <ScrollView style={styleDynamic.scrollView}>
          <View
            style={
              width > 1000
                ? {
                  backgroundColor: colors.background,
                  justifyContent: "center",
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: 974,
                  height: height,
                  flex: 1,
                }
                : {
                  backgroundColor: colors.background,
                  height: height,
                  flex: 1,
                }
            }
          >
            <View style={styleDynamic.container}>
              <View
                style={{
                  flexDirection: "column",
                }}
              >
                <View style={{}}>
                  <TouchableOpacity onPress={goBackToArticleListScreen}>
                    <Ionicons
                      name="md-arrow-back"
                      size={32}
                      color={colors.vectorColor}
                    />
                  </TouchableOpacity>
                </View>
              </View>

              {getArticleImage()}
              {getArticleContents()}
              <View style={{ flex: 3 }}>
                <CommentBox
                  colors={colors}
                  userId={userId}
                  username={username}
                  comments={comments}
                  appendComment={appendComment}
                  allowComments={allowComments}
                  articleId={articleId}
                  authToken={authToken}
                />
              </View>
              {false && (
                <View
                  style={{ flexDirection: "column", top: 50, height: height }}
                >
                  <View
                    style={{
                      flex: 3,
                      alignItems: "stretch",
                      justifyContent: "center",
                    }}
                  >
                    {articles.length > 0 && (
                      <>
                        <MonoText
                          style={{
                            marginTop: 18,
                            color: colors.text,
                            fontWeight: "bold",
                            fontSize: 18,
                          }}
                        >
                          {articles.length > 0 &&
                            articles.find(
                              (a) => a && a.id > 0 && a.id === articleId
                            ).headline}
                        </MonoText>
                        <MonoText
                          style={{
                            marginTop: 18,
                            color: colors.text,
                            fontSize: 18,
                          }}
                        >
                          {articles.find(
                            (a) => a && a.id > 0 && a.id === articleId
                          ).summary
                            ? articles.find(
                              (a) => a && a.id > 0 && a.id === articleId
                            ).summary
                            : "No article summary found."}
                        </MonoText>
                        <RenderHtml
                          tagsStyles={tagsStyles}
                          contentWidth={width}
                          source={{
                            html: `${replaceHtml(
                              articles.find(
                                (a) => a && a.id > 0 && a.id === articleId
                              ).text
                            )}`,
                          }}
                        />
                      </>
                    )}
                  </View>
                </View>
              )}
            </View>
          </View>
        </ScrollView>
      </SafeAreaView>
    </React.Fragment>
  );
}

ArticleScreen.navigationOptions = {
  header: null,
};

ArticleScreen.propTypes = {
  text: PropTypes.string,
};
